import { REFERRAL_STATUS } from '../referralStage/referralStage.types';

export type PointStatus = 'A' | 'B' | 'D';

export enum POINT_SETTING_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
}

export interface PointConfigurationData {
  pointCategoryId: string;
  agentType: string;
  agentTypeName?: string;
  categoryName: string;
  categoryType?: string | null;
  description: string;
  isDefault: boolean;
  status: PointStatus;
  createdDate: number;
  createdBy: string;
}

export type PointCategoryDetails = Omit<PointConfigurationData, 'status' | 'createdDate'>;

export interface PointCategoryPayload {
  agentType: string;
  categoryName: string;
  description: string;
}
export interface PointCategoryUpdatePayload extends PointCategoryPayload {
  pointCategoryId: string;
}
export interface PointCategoryStatusPayload {
  pointCategoryId: string;
  agentType: string;
  status: PointStatus;
}
export interface PointCategoryAssignPayload {
  pointCategoryId: string;
  agentType: string;
  agentId: string;
}

export interface SlabsData {
  pointSlabId: string;
  pointCategoryId?: string;
  fromAmount: number;
  toAmount: number;
  value: number;
  pointType?: string;
  pointValue?: number;
  minValue?: number;
  maxValue?: number;
  pointType2?: string | null;
  pointValue2?: number | null;
  minValue2?: number | null;
  maxValue2?: number | null;
  pointType3?: string | null;
  pointValue3?: number | null;
  minValue3?: number | null;
  maxValue3?: number | null;
  status?: PointStatus;
}

export interface PointSlabPayload {
  pointCategoryId: string;
  fromAmount: number;
  toAmount: number;
  pointType: string;
  pointValue: number;
  minValue: number;
  maxValue: number;
  pointType2?: string | null;
  pointValue2?: number | null;
  minValue2?: number | null;
  maxValue2?: number | null;
  pointType3?: string | null;
  pointValue3?: number | null;
  minValue3?: number | null;
  maxValue3?: number | null;
}

export interface PointSlabUpdatePayload extends Omit<PointSlabPayload, 'pointCategoryId'> {
  pointSlabId: string;
}
export interface PointSlabStatusPayload {
  pointSlabId: string;
  status: POINT_SETTING_STATUS;
}

export interface ManageReferralValidityPayload {
  affiliateToCustomer: string;
  affiliateToAffiliate: string;
  customerToCustomer: string;
}

export interface ManagePointSettingPayload {
  categoryId: string;
  category: string;
  description: string;
  programCode?: string;
  rewardPoint?: string;
}

export interface ManagePointSettingStatusPayload {
  categoryId: string;
  status: string;
}
export interface ManagePointCategoryPayload {
  userType: string;
  categoryType: string;
  categoryName: string;
  description: string;
}

export interface CustomerPointSettingListResponse {
  categoryId: string;
  category: string;
  description: string;
  programCode: string;
  categoryType: string;
  status: POINT_SETTING_STATUS;
  programId: string;
  createdBy: string;
  createdDate: number;
  rewardPoint?: string;
}

export interface CustomerReferralStageList {
  stageId: string;
  stageTitle: string;
  createdBy: string;
  createdDate: number;
  status: REFERRAL_STATUS;
}

export interface ManageReferralStageStatusPayload {
  stageId: string;
  status: string;
}

export interface CustomerReferralStageDetail {
  stageId: string;
  stageTitle: string;
  firstReservationCount: number;
  firstVisitRewardPoint: number;
  secondReservationCount: number;
  secondVisitRewardPoint: number;
  thirdReservationCount: number;
  thirdVisitRewardPoint: number;
  stageTwoReservationCount: number;
  stageTwoRewardPoint: number;
}

export interface ManageReferralStagePayload {
  stageId: string;
  stageTitle: string;
  firstVisitRewardPoint: string;
  secondVisitRewardPoint: string;
  thirdVisitRewardPoint: string;
  totalRewardForAllVisit: string;
}
